export function GridLines() {
  return (
    <div aria-hidden data-testid="grid-lines-overlay" className="pointer-events-none fixed inset-0 z-[1]">
      <div className="relative mx-auto h-full max-w-7xl px-4 sm:px-6 lg:px-12">
        <span className="grid-line left-4 sm:left-6 lg:left-12" />
        <span className="grid-line right-4 sm:right-6 lg:right-12" />
      </div>
    </div>
  );
}

export function SectionDivider() {
  return (
    <div aria-hidden className="relative z-[2] h-px w-full bg-white/[0.07]" />
  );
}
